import { render } from "./DistrictManagement.vue?vue&type=template&id=14019e02"
import script from "./DistrictManagement.vue?vue&type=script&lang=js"
export * from "./DistrictManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__